import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-regular-svg-icons'
import { faHandHoldingDollar, faSackDollar, faGear, faArrowRightFromBracket, faBars, faWallet, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import SidebarItem1 from "./SidebarItem1";
import { Toaster, toast } from 'react-hot-toast';
import { useUser } from "../utils/UserContext";
import { Link } from "react-router-dom"
import feather from 'feather-icons';
import ConnectBar from "./ConnectBar";

function Header({title, icon, toggleSidebar, toggleNotification, toggleSettingsBar }) {
  useEffect(() => {
    feather.replace();
  }, []);
  const [connectBar, setConnectBar] = useState(false);
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  const [profileInfo, setProfileInfo] = useState("closed")
  const [dropdown, setDropdown] = useState("closed")
  const [notifications, setNotifications] = useState([])
  const { user, setUser } = useUser();
  const logout = () => {
    fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ logout: true})
    })
    .then(response => response.text())
    .then(data => {
      if (data === "success") {
        window.location.href = "login";
      }else{
        toast.error("Logout failed");
      }
    })
    .catch(err => {
      console.error(err)
    }) 
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchNotification: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setNotifications(data.notifications);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, [user]);
  return (
    <>
      <Toaster/>
      <header className="header">
          <div className="d-flex align-items-center justify-content-center d-md-none" style={{ width: "35px", height: "35px", border: '1px solid #ffffff34', borderRadius: '6px', cursor: 'pointer' }} onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faBars} style={{color: 'gray', fontSize: '22px'}} />
          </div>
          <div className="d-lg-flex d-none align-items-center" style={{gap:'40px'}}>
              <Link to="/stock" className="fw-semibold text-white fw-semibold" style={{textDecoration:'none'}}>Stock <i data-feather="zap" height="14" className="lh-1"></i></Link>
          </div>
          <div className="d-flex align-items-center">
              <div className="myBtn me-2 fw-bold px-3 rounded-3 d-xl-block d-none" style={{fontSize:'14px',paddingTop:'12px',paddingBottom:'12px',backgroundColor: '#ffffff06'}} >{icon} <span className="ms-2">{title}</span></div>
              <div className="myBtn me-3 fw-bold px-3 rounded-3" style={{fontSize:'14px',paddingTop:'12px',paddingBottom:'12px'}} onClick={() => {toggleConnectBar()}}><FontAwesomeIcon icon={faWallet} className="me-2" /> Connect Wallet</div>
              <div className="position-relative d-flex align-items-center justify-content-center notify" style={{ width: "35px", height: "35px", border: '1px solid #ffffff34', borderRadius: '6px', cursor: 'pointer' }}
              onClick={toggleNotification}
              >
                  <FontAwesomeIcon icon={faBell} style={{fontSize: '18px'}} />
                  <span
                  className="position-absolute translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "0.5rem", top: '5px', right: '-5px' }}
                  >{notifications.length > 9 ? "9+" : notifications.length}</span>
              </div>
              <div
                className="d-flex align-items-center justify-content-center ms-2 rounded-2 overflow-hidden"
                style={{ width: "35px", height: "35px", border: '1px solid #ffffff34', borderRadius: '6px', cursor: 'pointer' }}
                onClick={() => {
                  setProfileInfo(profileInfo === "closed" ? "open" : "closed");
                }}
              >
                <i data-feather="settings" height="18" className="lh-1"></i>
              </div>
          </div>
          <div className={`profile-info ${profileInfo === "open" ? "open" : ""}`}>
              <SidebarItem1 icon={<FontAwesomeIcon icon={faHandHoldingDollar} />} label="Add funds" isActive={(title === "Deposit")?true:false} link="/deposit" />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faSackDollar} />} label="Withdraw funds" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faGear} />} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faBell} />} label="Notifications" isActive={(title === "Notifications")?true:false} onClick={toggleNotification}/>
              <SidebarItem1 icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />} label="Logout" isActive={(title === "Logout")?true:false} onClick={logout} />
          </div>
      </header>
      <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
    </>
  );
}

export default Header;